<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="EMPI">
              <a-input placeholder="请输入EMPI" v-model="queryParam.empi"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="身份证号">
              <a-input placeholder="请输入身份证号" v-model="queryParam.idcard"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="姓名">
              <a-input placeholder="请输入姓名" v-model="queryParam.name"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="联系号码">
              <a-input placeholder="请输入联系号码" v-model="queryParam.telephone1"></a-input>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="性别">
              <a-select v-model="queryParam.sex" placeholder="请输入性别" >
                <a-select-option :value="1">男</a-select-option>
                <a-select-option :value="0">女</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

            <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
                 <template v-if="status=='1'">
                    <a-button @click="handleAdd" type="primary" icon="plus" style="margin-left: 8px">新增</a-button>
                  <a-button @click="handleMerge" type="primary"  style="margin-left: 8px">合并索引</a-button>
                 </template>
                </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- table区域-begin -->
    <div>
      <div v-if="status=='1'" class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>已选择&nbsp;<a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项&nbsp;&nbsp;
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="empi"
        :columns="columns"
        :dataSource="dataSource"
        :rowSelection="status=='1'?{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}:undefined"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <template v-if="status=='1'">
            <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a @click="handlePixView(record)">交叉索引</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.empi)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
          </template>
          <template v-else>
            <a-popconfirm title="确定取消合并，还原当前主索引吗?" @confirm="() => handleCancelMerge(record.empi)">
                  <a>取消合并</a>
                </a-popconfirm>
          </template>

        </span>

      </a-table>
    </div>
    <!-- table区域-end -->
    <!-- 表单区域 -->
    <empi-modal ref="modalForm" @ok="modalFormOk"></empi-modal>
    <a-drawer
      title="交叉索引"
      :maskClosable="true"
      :width="'90%'"
      placement="right"
      :closable="true"
      @close="handlePixCancel"
      :visible="pixVisible"
      style="height: 100%;overflow: auto;padding-bottom: 53px;">
      <empi-pix-panel ref="empiPixPanel" :empi="currentRecord.empi"></empi-pix-panel>
    </a-drawer>
    <empi-merge-model ref="mergeModel" @ok="loadData"></empi-merge-model>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import EmpiModal from '../modules/EmpiModal'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import EmpiMergeModel from '../modules/EmpiMergeModel'
  import EmpiPixPanel from './EmpiPixPanel'
  import { getAction,postAction } from '@/api/manage'

  export default {
    name: "EmpiList",
    mixins:[JeecgListMixin],
    components: {
      EmpiPixPanel,
      EmpiMergeModel,
      EmpiModal
    },
    props:{
      status:{
        type:String,
        default:'1'
      }
    },
    data () {
      return {
        description: '主索引管理页面',
        // 表头
        columns: [
          {
            title: 'EMPI',
            width:200,
            align:"center",
            dataIndex: 'empi'
          },
          {
            title: '原EMPI',
            width:200,
            align:"center",
            dataIndex: 'baseEmpi'
          },
		   {
            title: '身份证号',
         width:200,
         ellipsis: true, //表格省略
         align:"center",
            dataIndex: 'idcard'
           },
		   {
            title: '姓名',
         width:150,
         align:"center",
            dataIndex: 'name'
           },
		   {
            title: '性别',
         width:100,
         align:"center",
            dataIndex: 'sex'
           },
		   {
            title: '出生日期',
         width:200,
         align:"center",
            dataIndex: 'birthDay'
           },
		   {
            title: '年龄',
         width:100,
         align:"center",
            dataIndex: 'age'
           },
		   {
            title: '备注',
            align:"center",
         ellipsis: true, //表格省略
         dataIndex: 'description'
           },
          {
            title: '操作',
            dataIndex: 'action',
            width:200,
            align:"center",
            scopedSlots: { customRender: 'action' },
          }
        ],
		url: {
          list: "/management/empi/list",
          delete: "/management/empi/delete",
       },
        pixVisible:false,
        disableMixinCreated:true,
        currentRecord:{},
    }
  },
  computed: {
  },
    mounted(){
      this.baseQueryParam = {status:this.status}
      this.loadData();
    },
    methods: {
      handlePixView(row){
        this.pixVisible = true
        this.currentRecord = row
      },
      handlePixCancel(){
        this.pixVisible = false
        this.currentRecord = {}
      },
      handleMerge(){
        this.$refs.mergeModel.open(this.selectionRows)
      },
      handleCancelMerge(empi){
        postAction("/management/empi/unmerge",{empi:empi}).then(res=>{
          if(res.success){
            this.loadData();
            this.onClearSelected()
          }
        })
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>